/* L7 Bewertungen Produktseite (snippets/gw-bewertungen.liquid). Ohne Bibliothek.
   - Server liefert Kopf, Verteilung und bis zu 5 Bewertungen. Gibt es mehr, lädt dieses Skript alle Bewertungen erst,
     wenn der Abschnitt in die Nähe kommt (IntersectionObserver) oder Filter/Sortierung bedient werden.
     Quelle: offizielle Judge.me-Widget-API (nur mit öffentlichem Token im Block), sonst der Endpunkt, den das
     Judge.me-Widget selbst nutzt (reviews_for_widget). Fällt beides aus: Server-Bewertungen + Link zu Judge.me bleiben.
   - Filter nach Sternen (Verteilung als Buttons), „Nur mit Fotos“ (nur wenn Fotos existieren), Sortierung, „Weitere laden“.
   - L11 (16.10.2026): kein „Bewertung schreiben“ mehr (Bewertungen nur über die Einladungs-E-Mail), daher kein Judge.me-JS nötig.
     Enthalten nachgeladene Bewertungen welche ohne „Verifizierter Kauf“, wird der Satz dazu im Echtheitshinweis eingeblendet. */
(function () {
  var root = document.querySelector('[data-gw-bew]');
  if (!root || root.__gwBew) return;
  root.__gwBew = true;
  var q = function (s) { return root.querySelector(s); };
  var total = parseInt(root.getAttribute('data-total'), 10) || 0;
  var ssr = parseInt(root.getAttribute('data-ssr'), 10) || 0;
  var step = parseInt(root.getAttribute('data-mehr'), 10) || 10;
  var liste = q('[data-gw-bew-liste]');
  var live = q('[data-gw-bew-live]');
  var STARS = '★★★★★';
  var CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PERSON = '<svg width="20" height="20" viewBox="0 0 24 24" focusable="false"><circle cx="12" cy="8" r="4" fill="none" stroke="currentColor" stroke-width="1.75"/><path d="M4 20c1.5-4 4.5-6 8-6s6.5 2 8 6" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var ansage = function (t) { if (!live) return; live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60); };
  var plural = function (n, e, m) { return n + ' ' + (n === 1 ? e : m); };

  if (!liste || total < 1) return;

  var tools = q('[data-gw-bew-tools]');
  var statusEl = q('[data-gw-bew-status]');
  var sortSel = q('[data-gw-bew-sort]');
  var foto = q('[data-gw-bew-foto]');
  var fotoWrap = q('[data-gw-bew-foto-wrap]');
  var fotoN = q('[data-gw-bew-foto-n]');
  var mehrBtn = q('[data-gw-bew-mehr]');
  var mehrInfo = q('[data-gw-bew-mehr-info]');
  var alle = q('[data-gw-bew-alle]');
  var sternBtns = Array.prototype.slice.call(root.querySelectorAll('[data-gw-bew-stern]'));
  var state = { stern: 0, foto: false, sort: 'neu', sicht: Math.max(ssr, 5) };
  var items = Array.prototype.slice.call(liste.querySelectorAll('[data-gw-bew-rev]')).map(fromEl);
  var komplett = items.length >= total;
  var laden = null;
  var fehler = false;

  function fromEl(el) {
    return { el: el, id: el.getAttribute('data-id'), r: +el.getAttribute('data-r') || 0, d: el.getAttribute('data-d') || '', f: +el.getAttribute('data-f') || 0 };
  }

  /* ---------- Daten nachladen ---------- */
  function apiUrl(page) {
    var shop = encodeURIComponent(root.getAttribute('data-shop') || '');
    var pid = encodeURIComponent(root.getAttribute('data-product-id') || '');
    var token = root.getAttribute('data-token');
    if (token) {
      return 'https://api.judge.me/api/v1/widgets/product_review?shop_domain=' + shop + '&api_token=' + encodeURIComponent(token) + '&external_id=' + pid + '&page=' + page + '&per_page=50';
    }
    return 'https://api.judge.me/reviews/reviews_for_widget?url=' + shop + '&shop_domain=' + shop + '&platform=shopify&product_id=' + pid + '&page=' + page + '&per_page=50&sort_by=created_at&sort_dir=desc';
  }
  function htmlAus(j) {
    if (!j || typeof j !== 'object') return '';
    if (typeof j.html === 'string') return j.html;
    for (var k in j) { if (typeof j[k] === 'string' && j[k].indexOf('jdgm-rev') > -1) return j[k]; }
    return '';
  }
  function holeSeite(page) {
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var t = ctrl ? setTimeout(function () { ctrl.abort(); }, 10000) : 0;
    return fetch(apiUrl(page), { credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { clearTimeout(t); if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) { return parse(htmlAus(j)); });
  }
  function ladeAlle() {
    if (komplett) return Promise.resolve();
    if (laden) return laden;
    var neu = [];
    var ids = {};
    var seite = function (p) {
      return holeSeite(p).then(function (list) {
        list.forEach(function (o) { if (!ids[o.id]) { ids[o.id] = 1; neu.push(o); } });
        if (list.length && neu.length < total && p < 10) return seite(p + 1);
      });
    };
    laden = seite(1).then(function () {
      if (!neu.length) throw new Error('leer');
      items = neu.map(function (o) { return { el: karte(o), id: o.id, r: o.r, d: o.d, f: o.pics.length }; });
      komplett = true;
      var altSatz = q('[data-gw-bew-hinweis-alt]');
      if (altSatz && neu.some(function (o) { return !o.v; })) altSatz.hidden = false;
    }).catch(function () {
      fehler = true;
    });
    return laden;
  }

  function txt(n) { return n ? (n.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function parse(html) {
    if (!html) return [];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.prototype.slice.call(doc.querySelectorAll('.jdgm-rev[data-review-id]')).map(function (n) {
      var sc = n.querySelector('[data-score]');
      var tm = n.querySelector('time[datetime]');
      var ts = n.querySelector('.jdgm-rev__timestamp[data-content]');
      var aw = n.querySelector('.jdgm-rev__author-wrapper');
      var body = n.querySelector('.jdgm-rev__body');
      var absatz = body ? Array.prototype.slice.call(body.querySelectorAll('p')).map(txt).filter(Boolean) : [];
      if (body && !absatz.length && txt(body)) absatz = [txt(body)];
      var pics = Array.prototype.slice.call(n.querySelectorAll('.jdgm-rev__pic-link')).map(function (a) {
        var img = a.querySelector('img');
        return { gross: a.getAttribute('href') || a.getAttribute('data-mfp-src') || '', klein: img ? (img.getAttribute('data-src') || img.getAttribute('src') || '') : '' };
      }).filter(function (p) { return /^https:\/\//.test(p.gross) && /^https:\/\//.test(p.klein); });
      var badges = Array.prototype.slice.call(n.querySelectorAll('[data-badge-type]')).map(function (b) { return b.getAttribute('data-badge-type'); });
      var autor = txt(n.querySelector('.jdgm-rev__author'));
      var anonym = (aw && aw.getAttribute('data-is-anonymous') === 'true') || !autor;
      return {
        id: n.getAttribute('data-review-id'),
        r: sc ? +sc.getAttribute('data-score') || 0 : 0,
        d: tm ? tm.getAttribute('datetime') : (ts ? (ts.getAttribute('data-content') || '').replace(' UTC', 'Z').replace(' ', 'T') : ''),
        autor: anonym ? 'Anonym' : autor,
        anonym: anonym,
        v: n.getAttribute('data-verified-buyer') === 'true',
        titel: txt(n.querySelector('.jdgm-rev__title')),
        text: absatz,
        pics: pics,
        antwort: txt(n.querySelector('.jdgm-rev__reply')).replace(/^(Antwort von [^:]{1,60}:|[^:]{1,60} replied:)\s*/i, ''),
        quelle: badges.indexOf('review_collected_from_another_provider') > -1 ? 'Von einem anderen Bewertungsanbieter übernommen.' : (badges.indexOf('review_written_in_shop_app') > -1 ? 'In der Shop App geschrieben.' : '')
      };
    });
  }
  function datum(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    try { return d.toLocaleDateString('de-DE', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' }); }
    catch (e) { return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear(); }
  }
  function karte(o) {
    var li = document.createElement('li');
    li.className = 'gw-bew-rev';
    li.tabIndex = -1;
    li.setAttribute('data-gw-bew-rev', '');
    var hid = 'gw-bew-' + String(o.id).replace(/[^\w-]/g, '');
    var fotos = '';
    if (o.pics.length) {
      fotos = '<ul class="gw-bew-rev__fotos" aria-label="Fotos von ' + esc(o.autor) + '">' + o.pics.map(function (p, i) {
        return '<li><a href="' + esc(p.gross) + '" target="_blank" rel="noopener nofollow"><img src="' + esc(p.klein) + '" alt="Kundenfoto ' + (i + 1) + ' von ' + o.pics.length + ', vergrößern (öffnet in neuem Fenster)" width="80" height="80" loading="lazy" decoding="async"></a></li>';
      }).join('') + '</ul>';
    }
    li.innerHTML = '<article aria-labelledby="' + hid + '"><div class="gw-bew-rev__kopf">' +
      '<span class="gw-bew-ava" aria-hidden="true">' + (o.anonym ? PERSON : esc(o.autor.charAt(0).toUpperCase())) + '</span>' +
      '<div class="gw-bew-rev__wer"><h3 class="gw-bew-rev__name" id="' + hid + '">' + esc(o.autor) + '</h3><div class="gw-bew-rev__zeile">' +
      '<span class="gw-bew-sterne gw-bew-sterne--s" role="img" aria-label="' + o.r + ' von 5 Sternen">' + STARS + '<span class="gw-bew-sterne__an" style="width:' + (o.r * 20) + '%" aria-hidden="true">' + STARS + '</span></span>' +
      '<time datetime="' + esc(o.d) + '">' + datum(o.d) + '</time>' +
      (o.v ? '<span class="gw-bew-badge">' + CHECK + 'Verifizierter Kauf</span>' : '') +
      '</div></div></div>' +
      (o.titel ? '<p class="gw-bew-rev__titel">' + esc(o.titel) + '</p>' : '') +
      (o.text.length ? '<p class="gw-bew-rev__text">' + o.text.map(esc).join('<br>') + '</p>' : '<p class="gw-bew-rev__leer">Nur Sterne vergeben, ohne Text.</p>') +
      fotos +
      (o.quelle ? '<p class="gw-bew-rev__quelle">' + o.quelle + '</p>' : '') +
      (o.antwort ? '<div class="gw-bew-rev__antwort"><p class="gw-bew-rev__antwort-h">Antwort von Guenstige-Whirlpools.de</p><p>' + esc(o.antwort) + '</p></div>' : '') +
      '</article>';
    li.setAttribute('data-id', o.id);
    li.setAttribute('data-r', o.r);
    li.setAttribute('data-d', o.d);
    li.setAttribute('data-f', o.pics.length);
    return li;
  }

  /* ---------- Darstellung ---------- */
  function gefiltert() {
    var l = items.filter(function (it) { return (!state.stern || it.r === state.stern) && (!state.foto || it.f > 0); });
    var neu = function (a, b) { return a.d < b.d ? 1 : a.d > b.d ? -1 : 0; };
    if (state.sort === 'neu') l.sort(neu);
    else if (state.sort === 'hoch') l.sort(function (a, b) { return b.r - a.r || neu(a, b); });
    else l.sort(function (a, b) { return a.r - b.r || neu(a, b); });
    return l;
  }
  function render() {
    var l = gefiltert();
    var shown = l.slice(0, state.sicht);
    var frag = document.createDocumentFragment();
    shown.forEach(function (it) { frag.appendChild(it.el); });
    liste.textContent = '';
    if (!l.length) {
      var leer = document.createElement('li');
      leer.className = 'gw-bew__leer-filter';
      leer.textContent = 'Keine Bewertungen mit dieser Auswahl.';
      frag.appendChild(leer);
    }
    liste.appendChild(frag);

    var filterText = [state.stern ? plural(state.stern, 'Stern', 'Sterne') : '', state.foto ? 'nur mit Fotos' : ''].filter(Boolean).join(', ');
    statusEl.innerHTML = (komplett
      ? '<b>' + l.length + '</b> von ' + plural(total, 'Bewertung', 'Bewertungen')
      : '<b>' + l.length + '</b> der ' + items.length + ' angezeigten von insgesamt ' + plural(total, 'Bewertung', 'Bewertungen')) +
      (filterText ? ' (' + esc(filterText) + ')' : '') +
      (filterText ? '<button type="button" class="gw-bew__reset" data-gw-bew-reset>Filter zurücksetzen</button>' : '');
    var rs = statusEl.querySelector('[data-gw-bew-reset]');
    if (rs) rs.addEventListener('click', function () {
      state.stern = 0; state.foto = false; state.sicht = Math.max(ssr, 5);
      if (foto) foto.checked = false;
      render();
      var h = document.getElementById(root.getAttribute('aria-labelledby'));
      if (h) h.focus();
      ansage('Filter zurückgesetzt. ' + plural(gefiltert().length, 'Bewertung', 'Bewertungen') + ' angezeigt.');
    });
    sternBtns.forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-gw-bew-stern') === state.stern ? 'true' : 'false'); });

    var nFoto = items.filter(function (it) { return it.f > 0; }).length;
    if (fotoWrap) { fotoWrap.hidden = nFoto < 1; if (fotoN) fotoN.textContent = nFoto; }

    var rest = l.length - shown.length;
    if (mehrBtn) {
      mehrBtn.hidden = !(komplett && rest > 0);
      mehrBtn.textContent = 'Weitere ' + plural(Math.min(rest, step), 'Bewertung', 'Bewertungen') + ' laden';
    }
    if (mehrInfo) {
      mehrInfo.hidden = !(rest > 0 || !komplett);
      mehrInfo.textContent = shown.length + ' von ' + (komplett ? l.length : total) + ' Bewertungen angezeigt.';
    }
    if (alle) alle.hidden = komplett && !fehler;
    var fe = q('[data-gw-bew-fehler]');
    if (fehler && !fe && alle) {
      fe = document.createElement('p');
      fe.className = 'gw-bew__fehler';
      fe.setAttribute('data-gw-bew-fehler', '');
      fe.textContent = 'Weitere Bewertungen lassen sich gerade nicht laden.';
      alle.parentNode.insertBefore(fe, alle);
    }
  }

  function mitDaten(fn) {
    if (komplett || fehler) { fn(); return; }
    root.setAttribute('aria-busy', 'true');
    ladeAlle().then(function () { root.removeAttribute('aria-busy'); fn(); });
  }

  sternBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var st = +b.getAttribute('data-gw-bew-stern');
      mitDaten(function () {
        state.stern = state.stern === st ? 0 : st;
        state.sicht = Math.max(ssr, 5);
        render();
        ansage(plural(gefiltert().length, 'Bewertung', 'Bewertungen') + (state.stern ? ' mit ' + plural(st, 'Stern', 'Sternen') : '') + ' angezeigt.');
      });
    });
  });
  if (foto) foto.addEventListener('change', function () {
    mitDaten(function () {
      state.foto = foto.checked; state.sicht = Math.max(ssr, 5);
      render();
      ansage(plural(gefiltert().length, 'Bewertung', 'Bewertungen') + ' angezeigt.');
    });
  });
  if (sortSel) sortSel.addEventListener('change', function () {
    mitDaten(function () {
      state.sort = sortSel.value; state.sicht = Math.max(ssr, 5);
      render();
      ansage('Sortierung geändert: ' + sortSel.options[sortSel.selectedIndex].text + '.');
    });
  });
  if (mehrBtn) mehrBtn.addEventListener('click', function () {
    var alt = state.sicht;
    state.sicht += step;
    render();
    var neu = liste.children[alt];
    if (neu && neu.focus) neu.focus();
    ansage(Math.min(state.sicht, gefiltert().length) + ' von ' + gefiltert().length + ' Bewertungen angezeigt.');
  });

  function bereit() {
    if (tools && (total > 1 || komplett)) tools.hidden = false;
    render();
  }
  if (komplett) {
    bereit();
  } else {
    /* Erst nachladen, wenn der Abschnitt in die Nähe kommt (oder sofort bei Sprung über #bewertungen) */
    var start = function () { ladeAlle().then(bereit); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '800px 0px' });
      io.observe(root);
    } else {
      start();
    }
  }
})();
